"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultCanSpamAddressIndex = getDefaultCanSpamAddressIndex;
exports.emailFooterIsSetUp = emailFooterIsSetUp;

var _underscore = require("underscore");

var _CanSpamSettings = require("lead-flows-ui/selectors/CanSpamSettings");

function getDefaultCanSpamAddressIndex(canSpamSettings) {
  var index = null;
  (0, _underscore.each)(Object.keys(canSpamSettings.objects || {}), function (key) {
    if (canSpamSettings.objects[key].isDefault) {
      index = key;
    }
  });
  return index;
}

function emailFooterIsSetUp(canSpamSettings) {
  var address = (0, _CanSpamSettings.getDefaultAddress)(canSpamSettings);
  return address && Boolean(address.companyName && address.companyStreetAddress_1 && address.companyCity && address.companyState);
}